
import React from 'react';
import ImpressumContainer from './impressum/ImpressumContainer';

const Impressum = () => {
  return <ImpressumContainer />;
};

export default Impressum;
